<template>
  <div class="example-drag">
    <div class="upload pt-2">
      <div class="px-1">
        <label
          for="file"
          class="rounded gj-dropzone mb-2 w-100"
        >
          <div class="text-center p-5 d-flex flex-column align-items-center">
            <GjIcon
              name="UploadCloud"
              size="64"
            />
            <file-upload
              ref="upload"
              v-model="files"
              class="text-sm mt-1"
              post-action="/upload/post"
              :multiple="true"
              :drop="true"
              :drop-directory="true"
            >
              <span>
                Drag and drop your file(s) anywhere or
                <span class="text-primary"> Browse </span> to choose a file.
              </span>
            </file-upload>
          </div>
        </label>
      </div>

      <div
        v-show="$refs.upload && $refs.upload.dropActive"
        class="drop-active"
      >
        <h3>Drop files to upload</h3>
      </div>
      <div class="px-1 mb-1">
        <b-form-group
          class="text-secondary"
          label="Select whether to set your file(s) to private or publicly readable:"
        >
          <b-form-radio-group
            v-model="isPublic"
            :options="options"
            name="upload-is-public"
            class="is-public"
            stacked
          />
        </b-form-group>
      </div>
      <div class="default-table shadow-none border-none table-compact">
        <b-table
          ref="filesTable"
          :items="tableFiles"
          :fields="fields"
          class="loaded"
          table-class="mt-0"
          sticky-header
          responsive
        >
          <template #cell(name)="data">
            <div
              v-if="data.value"
              v-b-tooltip.hover.v-default.bottom
              class="text-truncate"
              :title="data.value"
            >
              {{ data.value }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(type)="data">
            <div class="d-flex justify-content-between align-items-center">
              <span>
                {{ data.value }}
              </span>
              <span
                v-if="data.item.id !== null && data.item.id !== undefined"
                class="cursor-pointer"
                @click="removeFile(data.item.id)"
              >
                <GjIcon name="Close" />
              </span>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'

export default {
  name: 'UploadFiles',
  components: {
    FileUpload,
  },
  props: {
    value: {
      type: Object,
      default: () => ({ files: [], isPublic: false }),
      required: true,
    },
  },
  data() {
    return {
      isPublic: false,
      options: [
        { text: 'Private', value: false },
        { text: 'Public', value: true },
      ],
      files: [],
      fields: [
        {
          key: 'name',
          tdClass: 'upload-file-name',
        },
        {
          key: 'size',
          formatter: val => this.formatBytes(val) || '-',
        },
        {
          key: 'type',
          formatter: val => val || '-',
        },
      ],
    }
  },
  computed: {
    tableFiles() {
      return this.files.length
        ? this.files
        : [{ name: null, size: null, type: null }]
    },
    uploadData() {
      return {
        files: this.files,
        isPublic: this.isPublic,
      }
    },
  },
  watch: {
    files(val) {
      this.$emit('numberOfFiles', val.length)
      this.$emit('input', this.uploadData)
    },
    isPublic() {
      this.$emit('input', this.uploadData)
    },
  },
  beforeDestroy() {
    this.$emit('input', {})
  },
  methods: {
    removeFile(id) {
      this.files = this.files.filter(file => file.id !== id)
    },
  },
}
</script>

<style>
.example-drag .drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}
.example-drag .drop-active h3 {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
td.upload-file-name {
  max-width: 200px !important;
}

.is-public {
  margin-top: 14px;
}

.is-public .custom-control.custom-radio {
  margin-bottom: 10px;
}
</style>
